<div class="row align-items-center estimates-header">
  <div class="col-lg-12 mt-4">
    <div class="header-title">{{'' | i18n: 'support-docs'}}&nbsp;&nbsp;
      @if (isAdmin()) {
        <a (click)="showForm()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="#92A2BD" width="14px" height="18px" viewBox="0 0 45.40 45.40"
            xml:space="preserve" stroke="#92A2BD" stroke-width="0.00045402">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <g>
                <path
                  d="M41.267,18.557H26.832V4.134C26.832,1.851,24.99,0,22.707,0c-2.283,0-4.124,1.851-4.124,4.135v14.432H4.141 c-2.283,0-4.139,1.851-4.138,4.135c-0.001,1.141,0.46,2.187,1.207,2.934c0.748,0.749,1.78,1.222,2.92,1.222h14.453V41.27 c0,1.142,0.453,2.176,1.201,2.922c0.748,0.748,1.777,1.211,2.919,1.211c2.282,0,4.129-1.851,4.129-4.133V26.857h14.435 c2.283,0,4.134-1.867,4.133-4.15C45.399,20.425,43.548,18.557,41.267,18.557z">
                </path>
              </g>
            </g>
          </svg>
          <span>&nbsp;{{'' | i18n: 'warranty-condition-add-category'}}</span>
          <span id="hide" class="hide">
            <input id="category-add-input" type="text"/>
            <button id="category-add-button" (click)="createCategory()" type="button">Add</button>
          </span>
        </a>
      }
      &nbsp; &nbsp;
      @if (isAdmin()) {
        <a (click)="showDeleteForm()">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
            <path fill="#92A2BD" fill-rule="nonzero"
              d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z"/>
            </svg>
            <span>&nbsp;{{'' | i18n: 'warranty-condition-delete-category'}}</span>
            <span id="delete-hide" class="hide">
              <select [(ngModel)]="delCategory" id="category-delete-select">
                @for (f of fileListJson; track f) {
                  <option [value]="f.folder">
                    {{f.folder}}
                  </option>
                }
              </select>
              <button id="category-delete-button" (click)="deleteCategory()" type="submit">Delete</button>
            </span>
          </a>
        }
      </div>
    </div>
  </div>

  <div class="row detail-container">
    @for (item of fileListJson; track item) {
      <div>
        <app-admin-warranty-conditions [folderName]="item.folder" [folderFiles]="item.files">
        </app-admin-warranty-conditions>
      </div>
    }
  </div>

  <div class="row">
    <div class="col-12"><br/>&nbsp;<br/>&nbsp;<br/></div>
  </div>
